export default function Footer() {
  return (
    <footer className="border-t border-border">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between px-4 py-6 gap-4">
        <a
          className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
          href="https://quirence.ai"
          target="_blank"
          rel="noopener"
        >
          <span>&copy; {new Date().getFullYear()} Quirence</span>
        </a>
        <div className="flex items-center gap-4">
          <a
            href="https://quirence.ai/privacy"
            target="_blank"
            rel="noopener"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Privacy Policy
          </a>
          <a
            href="https://quirence.ai/terms"
            target="_blank"
            rel="noopener"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Terms of Service
          </a>
        </div>
      </div>
    </footer>
  );
}
